















import Vue from 'vue'
import { setCurrentPage } from '../store/actions'
import { getPagination, routerReplace } from '../helpers'
import { EventBus } from '../helpers/EventBus.vue' 
import { ITranslations } from '../store/state'

interface PaginationData {

}

interface PaginationMethods {
    setCurrentPage(event: Event, number: number): void
}

interface PaginationComputed {
    pages: number
    currentPage: number
    mayPrev: boolean
    mayNext: boolean,
    paginationPages: any,
	translations: ITranslations
}

interface PaginationProps {
    
}


export default Vue.extend<{}, PaginationMethods,  PaginationComputed, PaginationProps>({
	name: 'Pagination',
	
    computed: {
        paginationPages() {
            const pages = this.$store.getters.pages;
            const currentPage = this.$store.getters.page;

            return getPagination(pages, currentPage);
        },
        pages() {
            return this.$store.getters.pages
        },
        currentPage() {
            return this.$store.getters.page
        },
        mayPrev() {
            return this.$store.getters.page > 0;
        },
        mayNext() {
            return this.$store.getters.page !== (this.$store.getters.pages - 1)
        },
        translations() {
			return this.$store.getters.translations
		}
    },
    methods: {
        setCurrentPage(event, number) {
            event.preventDefault()
            EventBus.$emit('scrollToTop');
            this.$store.dispatch(setCurrentPage({page: number}))
            routerReplace({
				query: this.$store.getters.getParams
			})
        }
    }
})
